import { sortArray } from './array'

/**
 * Sort object by keys (only own properties will be sorted).
 * @param {object} obj object to sort keys
 * @param {bool} reverse false - reverse sorting.
 * @returns {object} object with ordered properties.
 */
export function sortObjectKey (obj, reverse) {
  reverse = reverse || false // by default no reverse
  const reversed = (reverse) ? -1 : 1
  let sortable = [] // array in format [ [ key1, val1 ], [ key2, val2 ], ... ]
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      sortable.push([key, obj[key]])
    }
  }
  sortable.sort(function (a, b) {
    const x = a[0].toLowerCase()
    const y = b[0].toLowerCase()
    return x < y ? reversed * -1 : x > y ? reversed : 0
  })
  let newObject = {}
  sortable.forEach((value) => {
    newObject[value[0]] = value[1]
  })
  return newObject
}

/**
 * Sort object by values (only own properties will be sorted).
 * @param {object} obj object to sort values
 * @param {bool} isNumericSort true - sort object values as numeric value, false - sort as string value.
 * @param {bool} reverse false - reverse sorting.
 * @returns {object} object with ordered properties.
 */
export function sortObjectValues (obj, isNumericSort, reverse) {
  isNumericSort = isNumericSort || false // by default text sort
  reverse = reverse || false // by default no reverse
  const reversed = (reverse) ? -1 : 1
  let sortable = [] // array in format [ [ key1, val1 ], [ key2, val2 ], ... ]
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      sortable.push([key, obj[key]])
    }
  }
  if (isNumericSort) {
    sortable.sort(function (a, b) {
      return reversed * (a[1] - b[1])
    })
  } else {
    sortable.sort(function (a, b) {
      const x = a[1].toLowerCase()
      const y = b[1].toLowerCase()
      return x < y ? reversed * -1 : x > y ? reversed : 0
    })
  }
  let newObject = {}
  let newIndex = 0
  sortable.forEach(value => {
    if (isNaN(value[0])) {
      newObject[value[0]] = value[1]
    } else {
      newObject[newIndex] = value[1]
      newIndex++
    }
  })
  return newObject
}

/**
 * Merge objects filling empty keys.
 * @param {object} objs objects to merge keys and ordered
 * @param {any} defaultValue value to use when key has empty value.
 * @returns {object} object with property merged.
 */
export function mergeObjects (objs, defaultValue, isNumericSort) {
  let uniqKeys = sortArray(Object.keys(objs).reduce((keys, index) => {
    return keys.concat(Object.keys(objs[index]))
  }, []).filter((value, index, self) => {
    return self.indexOf(value) === index
  }), isNumericSort)
  return Object.keys(objs).reduce((objsSorted, index) => {
    uniqKeys.forEach(key => {
      if (!objsSorted[index]) { objsSorted[index] = {} }
      if (!objs[index][key]) {
        if (isNumericSort) {
          objsSorted[index][Number(key)] = defaultValue
        } else {
          objsSorted[index][key] = defaultValue
        }
      } else {
        if (isNumericSort) {
          objsSorted[index][Number(key)] = objs[index][key]
        } else {
          objsSorted[index][key] = objs[index][key]
        }
      }
    })
    return objsSorted
  }, {})
}



// WEBPACK FOOTER //
// ./src/utils/object.js